import { MediaUpload } from '@wordpress/block-editor';
import { Button } from '@wordpress/components';
import {
  MediaReplaceButton,
  MediaRemoveButton,
} from '@components/media-upload';

const {
  i18n: { __ },
} = wp;

const MobileImage = ({ setAttributes, mobileImage }) => {
  return (
    <>
      <span className="title-label">Mobile Image</span>
      <MediaUpload
        onSelect={(media) => {
          setAttributes({
            mobileImage: {
              id: media.id,
              title: media.title,
              filename: media.filename,
              url: media.url,
              fileType: media.type,
            },
          });
        }}
        type="image"
        allowedTypes={['image']}
        value={mobileImage.id}
        render={({ open }) => (
          <div className="media-upload image-upload">
            {mobileImage.url && (
              <div className="upload-buttons-wrapper">
                <MediaReplaceButton onClick={open} />
                <MediaRemoveButton
                  onClick={() => {
                    setAttributes({ mobileImage: {} });
                  }}
                />
              </div>
            )}
            {!mobileImage.url && (
              <Button className="media-button upload-button" onClick={open}>
                {__('Upload Image', 'b3rg')}
              </Button>
            )}
            {mobileImage.url && (
              <div
                className="image-thumb-wrapper"
                onClick={open}
                onKeyUp={open}
                role="button"
                tabIndex="0"
              >
                <img className="image-thumb" src={mobileImage.url} alt="" />
              </div>
            )}
          </div>
        )}
      ></MediaUpload>
    </>
  );
};

export default MobileImage;
